// import CircularProgress from '@mui/material/CircularProgress';
import './Loading.css'; // Arquivo de estilos CSS para o componente de loading

export default function LoadingShort({ text }) {
    return (
        <div className="loading-container" >
            <div className="loaderShort"></div>

            {text && <p >{text}</p>}
        </div>
    )
}